import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class sysAccountParallelVoucherListRuleAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'SysAccountParallelVoucherListRules';
}

export default new sysAccountParallelVoucherListRuleAPI();
